import React from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

import EntityForm from '../../../../components/form/base/EntityForm';
import { KeywordValues } from '../../model/keywordModel';
import TextField from '../../../../components/form/elements/TextField';
import { TEXT_FIELD_COLOR, TEXT_FIELD_TYPE, TEXT_FIELD_VARIANT } from '../../../../components/form/enum/formProps';
import Title from '../../../../components/Title';
import Breadcrumbs from '../../../../components/Breadcrumbs';
import { BreadcrumbsLinkData } from '../../../../components/Breadcrumbs/model/breadcrumbsModel';

interface KeywordFormProps {
  title: string;
  breadcrumbs: BreadcrumbsLinkData[];
  initialValues: KeywordValues;
  onSubmit: (values: KeywordValues) => void;
}

const validationSchema = Yup.object().shape({
  name: Yup.string().min(2, 'validation.too_short').required('validation.is_required'),
});

const KeywordForm: React.FC<KeywordFormProps> = (props) => {
  const { t } = useTranslation();

  return (
    <>
      <Title>{t(props.title)}</Title>
      <Breadcrumbs title={props.title} links={props.breadcrumbs} hide />
      <EntityForm<KeywordValues>
        initialValues={props.initialValues}
        validationSchema={validationSchema}
        onSubmit={props.onSubmit}
      >
        <TextField
          name="name"
          label="keyword.name"
          type={TEXT_FIELD_TYPE.TEXT}
          color={TEXT_FIELD_COLOR.PRIMARY}
          variant={TEXT_FIELD_VARIANT.STANDARD}
        />
      </EntityForm>
    </>
  );
};

export default KeywordForm;
